module.exports = __webpack_public_path__ + "media/images/monde-ouvert-de6d0fdc2fa20b1824038ba352b5de5d.jpg";